import Vue from 'vue';
import $ from "jquery";
import draggable from 'vuedraggable';
import AjaxUtils from "./util/ajax_utils";
import {ClearToken, GetToken} from "./util/jwt";
import jwt_decode from "jwt-decode";
import Store from "./data/store";
import { formatDate, adjustTimezone, parseDate, yearsDiff } from './util/dateUtils';
import * as showdown from 'showdown';
import {ApckNavigation} from "./components/navigation/navigation";
import getcookie from "./util/getcookie";
import {ApckColumnActions} from "./components/form";
import cloneDeep from "lodash/cloneDeep";
import { toastMessage } from './components/_ui/_utils/useEventUtils'
import { defineComponent } from 'vue'
import UiInputCheckbox from '@/components/_ui/Form/Input/Checkbox/InputCheckbox.vue'

export default defineComponent({
    components: { UiInputCheckbox },
})


showdown.setOption('ghCodeBlocks', true);
showdown.setOption('tables', true);

showdown.extension('tourButton', function() {
    return [{
        type: 'lang',
        regex: /\[tour:([^\]]+)\](.*?)\[\/tour\]/g,
        replace: function(match, action, text) {
            // Replace with your Vue.js button component template
            // [tour:action]Button Text[/tour]
            // For example, <div class="btn btn-positive" data-tour="${action}">${text}</div>
            // Make sure to bind the action and text appropriately to your component
            return `<div class="btn btn-positive" data-tour="${action}">${text}</div>`;
        }
    }];
});

showdown.extension('tourTitle', function() {
    return [{
        type: 'lang',
        regex: /\[tourTitle:([^\]]+)\](.*?)\[\/tourTitle\]/g,
        replace: function(match, action, text) {
//Needs to be this way to prevent escaping
            return `
<div class="heading-holder">
    <header class="header-actionable header">
        <div class="title-div title">
            <h1 class="title-primary">${text}</h1>
        </div>
        <div class="actions">
            <div class="btn btn-positive" data-tour="${action}">
                Take The Tour
            </div>
        </div>
    </header>
</div>
            `;
        }
    }];
});

showdown.extension('showmeButton', function() {
    return [{
        type: 'lang',
        regex: /\[showme:([^\]]+)\](.*?)\[\/showme\]/g,
        replace: function(match, action, text) {
            return `<div class="btn btn-secondary" data-showme="${action}">${text}</div>`;
        }
    }];
});

showdown.extension('showmeTitle', function() {
    return [{
        type: 'lang',
        regex: /\[showmeTitle:([^\]]+)\](.*?)\[\/showmeTitle\]/g,
        replace: function(match, action, text) {
//Needs to be this way to prevent escaping
            return `
<div class="heading-holder">
    <header class="header-actionable header">
        <div class="title-div title">
            <h2 class="title-primary">${text}</h2>
        </div>
        <div class="actions">
            <div class="btn btn-secondary" data-showme="${action}">
                Show Me
            </div>
        </div>
    </header>
</div>
            `;
        }
    }];
});

showdown.extension('styledTable', function() {
    return [
        {
            type: 'lang',
            filter: (text, converter) => text.replace(
              /\[styledTable]((.|\n|\r)*?)\[\/styledTable\]/g,
              (match, p1, _, string, groups) => converter
                .makeHtml(p1)
                .replace('<table>', `<table class="ht-default">`)
            ),
        },
        {
            type: 'lang',
            filter: (text, converter) => text.replace(
              /\[styledTable:(.*?)\]((.|\n|\r)*?)\[\/styledTable\]/g,
              (match, p1, p2, _, string, groups) => converter
                 .makeHtml(p2)
                .replace('<table>', `<table class="ht-default ${p1.split(',').map(c => 'ht-' + c).join(' ')}">`)
            ),
        },
    ]
});

showdown.extension('conditionalPermissions', function(){
    return [{
        type: 'lang',
        regex: /\{\{if (\w+)\}\}([\s\S]*?)\{\{endif\}\}/g,
        replace: function(match, permission, content) {
            let permissions = {};
            if(Vue.prototype.hasOwnProperty('$permissions')) {
                permissions = Vue.prototype.$permissions;
            }
            if (permissions[permission]) {
                // If the condition is true, return the content
                return content;
            }
            // If the condition is false, return an empty string
            return '';
        }
    }];
});


export const ApckMainHeader = {
    props: {
        // accept a string href for the logo
        href: {
            type: String,
            default: '',
        },
    },
    template: `
        <header id="header" role="banner">
            <div class="c-logo">
                <a :href="href">
                    <div id="logo">
                    </div>
                </a>
            </div>
        </header>
    `,
};

export const ApckMainNavBar = {
    props: {
        enabled: Boolean,
        userName: String,
        userUrl: String,
        impersonating: Boolean,
        impersonatingMany: Boolean
    },
    computed: {
        jwt() {
            return jwt_decode(GetToken());
        },
        backendPermission() {
            return this.$permissions?.backend_permission || false;
        },
        // impersonating() {
        //     return Boolean(this.jwt.imp_id);
        // },
        // userUrl() {
        //     return "/users/" + this.jwt.sub;
        // },
        dashboardUrl() {
            return "/spa/";
        },
    },
    methods: {
        openSettings() {
            window.location.href = '/settings';
        },
        impersonationBack() {
            AjaxUtils.ajax_get({
                url: '/security/back',
                success: function () {
                    // TODO: Won't need to reload the page when are using the JWT as a datasource instead of session
                    window.location.reload();
                }
            })
        },
        impersonationStop() {
            AjaxUtils.ajax_get({
                url: '/security/reset',
                success: function () {
                    // TODO: Won't need to reload the page when are using the JWT as a datasource instead of session
                    window.location.reload();
                }
            })
        },
        logout() {
            window.location.href = '/security/logout';
            ClearToken();
        },
    },
    template: `
        <div class="h-nav-bar">
            <p v-if="enabled" class="welcome">
                <span class="username">
                     {{ impersonating ? "You are acting as" : "Welcome," }}
                     <a :href="userUrl">{{ userName }}</a>
                </span>
            </p>
            <div v-if="enabled" :class="['identity', impersonating ? 'impersonator' : '']">
                <div class="actions">
                    <router-link
                        v-if="this.$route.meta?.admin_nav_only"
                        :to="{name: 'dashboard'}"
                        activeClass=""
                        exactActiveClass=""
                        class="btn btn-secondary"
                        title="Back to Scanner"
                    >
                      <i class="fa fa-undo"></i>
                      <span class="req-large">Back to Scanner</span>
                    </router-link>
                    <router-link
                        v-else-if="backendPermission"
                        :to="{name: 'admin.dashboard'}"
                        activeClass=""
                        exactActiveClass=""
                        class="btn btn-secondary"
                        title="Admin Panel"
                    >
                      <i class="fa fa-user"></i>
                      <span class="req-large">Admin Panel</span>
                    </router-link>

                    <apck-button
                        icon="fa-cog"
                        class="btn-secondary"
                        span-class="req-large"
                        :handler="openSettings"
                        title="Settings"
                        value="Settings"
                    />

                    <apck-button
                        v-if="impersonatingMany"
                        icon="fa-user-times"
                        class="btn-negative"
                        span-class="req-large"
                        :handler="impersonationBack"
                        title="Rollback Impersonation"
                        value="Back"
                    />
                    <apck-button
                        v-else-if="impersonating"
                        icon="fa-user-times"
                        class="btn-negative"
                        span-class="req-large"
                        :handler="impersonationStop"
                        title="Stop Impersonation"
                        value="Stop"
                    />

                    <apck-button
                        icon="fa-sign-out"
                        class="btn-secondary"
                        span-class="req-large"
                        :handler="logout"
                        title="Log Out"
                        value="Log Out"
                    />
                </div>
            </div>
        </div>
    `
}

export const ApckMainBody = {
    components: {
        'apck-navigation': ApckNavigation,
    },
    props: {
        support: {
            type: Boolean,
            default: false
        },
        notifications: {
            type: Object,
            default: null
        },
        user: {
            type: Object,
            default: null
        },
        userSettingsUrl: {
            type: String,
            default: '/settings'
        },
        logoutUrl: {
            type: String,
            default: '/security/logout'
        },
        impersonation: {
            type: Object,
            default: null
        },
        navLinks: {
            type: Array,
            default: null
        },
        extraLinks: {
            type: Array,
            default: null
        },
        hideLogo: {
            type: Boolean,
            default: false
        },
        collapsedStateCookie: {
            type: Boolean,
            default: false
        },
        contentTargetId: String,
        adminPanelDisabled: {
            type: Boolean,
            default: true,
        },
        rightArrowClass: {
            type: String,
            default: 'fa-arrow-right-to-line',
        },
        leftArrowClass: {
            type: String,
            default: 'fa-arrow-left-to-line',
        },
        routeFilter: {
            type: Function,
            default: undefined,
        },
        deepCloneChildren: {
            type: Boolean,
            default: true,
        },
        getParent: {
            type: Function,
            default: undefined,
        },
        whatsNew: {
            type: Boolean,
            default: true,
        },
        trash: {
            type: Boolean,
            default: true,
        },
    },
    data: function () {
        return {
            sidebarCollapsed: false,
            impersonating: false,
            routerReady: false
        }
    },
    computed: {
        hideSidebar() {
            if (!this.routerReady) {
                return true;
            }

            return this.$route.matched.some(route => route.meta && route.meta.no_sidebar);
        },
        sidebar () {
            return !this.hideSidebar;
        }
    },
    methods: {
        setCollapseState(state) {
            this.sidebarCollapsed = state;
            if (this.collapsedStateCookie) {
                document.cookie = `sidebar_collapsed=${state}; path=/; max-age=${60 * 60 * 24 * 365}; SameSite=Lax`;
            }
        }
    },
    created() {
        if (this.collapsedStateCookie) {
            this.sidebarCollapsed = getcookie('sidebar_collapsed') === 'true';
        }

        this.$router.onReady(() => {
            this.routerReady = true;
        });
    },
    mounted() {
        if (this.contentTargetId) {
            const oldParent = document.getElementById(this.contentTargetId);
            if (oldParent) {
                this.$refs.target.appendChild(oldParent.childNodes[0]);
            } else {
                console.warn(`Content target ${this.contentTargetId} not found.`);
            }
        }
    },
    template: `
        <div class="apck-container">
            <div v-if="sidebar" :class="['navigation-slot', sidebarCollapsed ? 'collapsed' : '']">
                <apck-navigation
                    @update:collapse="setCollapseState($event)"
                    :key="$route.path"
                    :startCollapsed="sidebarCollapsed"
                    :support="support"
                    :notifications="notifications"
                    :user="user"
                    :userSettingsUrl="userSettingsUrl"
                    :logoutUrl="logoutUrl"
                    :impersonation="impersonation"
                    :links="navLinks"
                    :extra-links="extraLinks"
                    :hide-logo="hideLogo"
                    :adminPanelDisabled="adminPanelDisabled"
                    :rightArrowClass="rightArrowClass"
                    :leftArrowClass="leftArrowClass"
                    :routeFilter="routeFilter"
                    :deepCloneChildren="deepCloneChildren"
                    :getParent="getParent"
                    :whatsNew="whatsNew"
                    :trash="trash"

                ></apck-navigation>
            </div>

            <div class="content">
                <router-view v-if="!contentTargetId"></router-view>
                <div v-else ref="target"></div>
            </div>
        </div>
    `
}

export const ApckHelp = {
    props: {
        src: {
            type: String,
            default: null
        }
    },
    data: function() {
        return {
            showHelp: false,
            helpData: ''
        }
    },
    created() {
        var cmp = this;
        cmp.fetchHelp();
    },
    watch: {
        '$route': 'fetchHelp'
    },
    methods: {
        openHelp: function() {
            this.showHelp = true;
        },
        closeHelp: function() {
            this.showHelp = false;
        },
        fetchHelp: function() {
            var cmp = this;
            var url = '/assets/resources/userguide/new/' + cmp.currentRouteName + '.md';
            //Allow some overriding, could override with a function later
            if(cmp.src) {
                url = cmp.src;
            }
            let converter = new showdown.Converter({extensions: ['conditionalPermissions', 'showmeTitle', 'tourButton', 'tourTitle', 'showmeButton', 'styledTable']});
            AjaxUtils.ajax_get({
                url: url,
                success: function (data) {

                    if (data) {
                        cmp.helpData = converter.makeHtml(data);
                    } else {
                        cmp.helpData = '';
                    }
                },
                fail: function (data) {
                    if (data) {
                        cmp.helpData = converter.makeHtml(data);
                    } else {
                        cmp.helpData = '';
                    }
                },
                opts: {
                    dataType: '*/*',
                    flash_form_errors: false,
                    flash_404_errors: false
                }
            });
        }
    },
    computed: {
        currentRouteName() {
            return this.$route.name;
        }
    },
    template: `
        <div class="help">
            <div
                class="help-button"
                v-on:click="openHelp()"
            />

            <div v-if="showHelp" class="help-container">
                <div class="title-bar force-menu">
                    <span class="title-text">Help Menu</span>
                    <div class="title-menu collapse-menu">
                        <a v-on:click="closeHelp()" href="javascript:;" class="title-button style-negative">
                            <i class="fa fa-close"></i>
                        </a>
                    </div>
                </div>
                <div class="help-inner">
                    <div class="markdown" v-html="helpData" />
                </div>
            </div>
        </div>
    `
}

export const ApckSpinner = {
    props: {
        state: {
            type: Object,
            required: true
        }
    },
    computed: {
        progress_bar: function() {
            var found = false;
            var progress_bar = {
                "datasets": [{
                    "data": [],
                    "backgroundColor": []
                }],
                "labels": []
            };
            var state = this.get_state;
            var stage = this.state.stage;

            this.state.stages.forEach(function(_stage){
                var data = 1;
                var backgroundColor = '#27ae60';

                if (['COMPLETED', 'PASSED', 'FAILED'].indexOf(state) == -1){
                    if (_stage == stage){
                        found = true;
                        backgroundColor = "#f39c12";
                    }
                    else if (found) {
                        backgroundColor = "#c0392b";
                    }
                }


                progress_bar['datasets'][0]['data'].push(data);
                progress_bar['datasets'][0]['backgroundColor'].push(backgroundColor);
            });

            return JSON.stringify(progress_bar);

        },
        running: function() {
            return this.get_state == "RUNNING";
        },
        get_state: function() {
            var DETACHED_TIMEOUT = 5 * 60;

            var INITIALISIING = "INITIALISIING";
            var RUNNING = "RUNNING";
            var PAUSED = "PAUSED";
            var ABORTING = "ABORTING";
            var COMPLETED = "COMPLETED";
            var PASSED = "PASSED";
            var FAILED = "FAILED";
            var ABORTED = "ABORTED";
            var DETACHED = "DETACHED";
            var PENDING = "PENDING";

            //First check the outcome, if the scan has declared itself finished
            var outcome = this.state.outcome ? this.state.outcome : null;

            if (outcome == "succeeded") {
                return COMPLETED;
            }
            else if( outcome == "aborted") {
                return ABORTED;
            }
            else if (outcome == "failed") {
                return FAILED;
            }

            if (this.state.state) {
                var state_lower = this.state.state.toLowerCase();

                if (state_lower == "running"){
                    return RUNNING;
                }

                else if (state_lower == "paused") {
                    return PAUSED;
                }

                else if (state_lower == "pending") {
                    return PENDING;
                }
            }

            var time_since_update = ((Date.getTime() / 1000) - (this.state.updated_at || this.state.started));
            //console.log(time_since_update);

            if (time_since_update < DETACHED_TIMEOUT) {
                return RUNNING;
            }

            return DETACHED;
        },
        _state: function() {
            function capitalizeFirstLetter(string) {
                string = string.toLowerCase();
                return string.charAt(0).toUpperCase() + string.slice(1);
            }

            var nice_state = capitalizeFirstLetter(this.get_state);
            var mapping = {
                INITIALISIING: {
                    icon: 'fa-cogs',
                    name: nice_state,
                    class: ''
                },
                RUNNING: {
                    icon: 'fa-spinner fa-pulse',
                    name: nice_state,
                    class: ''
                },
                PAUSED: {
                    icon: 'fa-pause',
                    name: nice_state,
                    class: ''
                },
                ABORTED: {
                    icon: 'fa-exclamation',
                    name: nice_state,
                    class: 'emphasis-bad'
                },
                ABORTING: {
                    icon: 'fa-exclamation',
                    name: nice_state,
                    class: 'emphasis-bad'
                },
                COMPLETED: {
                    icon: 'fa-check',
                    name: nice_state,
                    class: 'emphasis-good'
                },
                PASSED: {
                    icon: 'fa-check',
                    name: nice_state,
                    class: 'emphasis-good'
                },
                FAILED: {
                    icon: 'fa-remove',
                    name: nice_state,
                    class: 'emphasis-bad'
                },
                DETACHED: {
                    icon: 'fa-warning',
                    name: nice_state,
                    class: 'emphasis-neutral'
                },
                PENDING: {
                    icon: 'fa-question fa-spin',
                    name: nice_state,
                    class: ''
                }
            }

            var rtn = mapping[this.get_state];

            if(!rtn) {
                rtn = {
                    icon: 'fa-question fa-spin',
                    name: 'Pending',
                    class: ''
                };
            }

            return rtn;
        }
    },
    mounted: function() {
        var self = this;
        self.charts = [];
        $(self.$el).find('.js-chart').each(function(){
            var $chart = $(this);
            var $canvas = $('<canvas width="280" />');
            var ctx = $canvas.get(0).getContext('2d');

            $canvas.appendTo($chart);
            new Chart(ctx, {
                type: $chart.data('type'),
                data: $chart.data('json'),
                options: {
                    cutoutPercentage: 75,
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: false,
                    },
                    animation: {
                        animateRotate: false,
                        animateScale: true
                    },
                    tooltips: {
                        enabled: false
                    }
                }
            });
        });
    },
    template: `
        <div class="progress">
            <div class="js-chart" data-type="pie" v-bind:data-json="progress_bar"></div>
            <div v-if="!running">
                <span class="progress-icon">
                    <i v-bind:class="['fa', _state.icon]"></i>
                </span>
                <strong>{{_state.name}}</strong>
            </div>

            <div v-if="running">
                <span v-if="state.progress" style="font-size: 20px;" class="progress-icon">
                    {{ (state.progress * 100).toFixed(0) }}%
                </span>
                <span v-else class="progress-icon">
                    <i v-bind:class="['fa', _state.icon]"></i>
                 </span>
                <strong>{{_state.name}}</strong>

                <strong v-if="state.stage">
                    {{state.stage}}
                </strong>
            </div>
        </div>
    `
}

export const ApckLayout = {
    props: {
        padded: {
            type: Boolean,
            default: true
        }
    },
    template: `
        <div class="layout" role="main">
            <div v-if="$slots.sidebar" class="layout-sidebar req-large">
                <slot name="sidebar" />
            </div>
            <div v-bind:class="[
                    $slots.sidebar ? 'sidebar' : '',
                    !padded ? 'no-padding' : '',
                    'layout-main'
                ]"
            >
                <slot />
            </div>
        </div>
    `
}

export const ApckTitleBar = {
    props: {
        title: {
            type: String,
            default: "Title"
        }
    },
    template: `
        <header class="header-actionable header ">
            <div class="title-div title">
                <h1 class="c-title c-title title-primary">
                    {{ title }}
                </h1>
            </div>
            <div v-if="$slots.actions" class="actions">
                <slot name="actions" />
            </div>
        </header>
    `
}

export const ApckPanel = {
    props: {
        title: {
            type: String,
            default: null
        },
        headerTitle: {
            type: Boolean,
            default: false,
            required: false
        },
        icon: {
            type: String,
            default: null
        },
        noPadding: {
            type: Boolean,
            default: false
        },
        noBorder: {
            type: Boolean,
            default: false
        },
        dashboardMode: {
            type: Boolean, // enables the dashbaord class for styling inner panels
            default: false
        },
        draggable: {
            type: Boolean,
            default: false
        },
        forceMenu: {
            type: Boolean,
            default: false
        },
        titleBar: {
            type: Boolean,
            default: false
        }
    },
    template: `
        <div v-bind:class="[noBorder ? 'no-border' : '', 'panel']">

            <apck-title
                v-if="title"
                :title="title"
                :header="headerTitle"
                :icon="icon"
                :force-menu="forceMenu"
                v-bind:class="[draggable ? 'drag-handle' : '', titleBar ? 'title-bar-header' : '']"
            >
                <template v-slot:default="data">
                    <slot name="menu" v-bind="data" />
                </template>
            </apck-title>

            <slot name="tbar" />

            <div v-bind:class="['panel-body', noPadding ? 'no-padding' : '', dashboardMode ? 'dashboard' : '']">
                <slot />
            </div>

            <slot name="bbar" />
        </div>
    `
}

export const ApckSep = {
    template: `
        <span class="sep"></span>
    `
}

export const ApckTitle = {
    props: {
        title: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: false
        },
        forceMenu: {
            type: Boolean,
            default: false
        },
        header: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    computed: {
        menu: function() {
            let have_slots = false;
            try {
                have_slots = this.$scopedSlots && this.$scopedSlots.default ? this.$scopedSlots.default().length > 0 : false;
            } catch(e) {

            }
            return have_slots;
        }
    },
    template: `
        <div :class="['title-bar', header ? 'title-bar-header' : '']">
            <span class="title-text">
                <i v-if="icon" v-bind:class="['fa', icon]" />
                {{ title }}
            </span>
            <div v-if="menu" v-bind:class="[forceMenu ? 'force-menu' : '', 'title-menu']">
                <slot />
            </div>
        </div>
    `
}

export const ApckButton = {
    props: {
        handler: {
            type: Function
        },
        title: {
            type: String,
            default: null
        },
        value: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: null
        },
        right: {
            type: Boolean,
            default: false
        },
        spanClass: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        btnclick: function(event, ...props) {
            if (this.disabled) {
                return;
            }
            // Black magic, :)
            // basically it allows any arguments to be passed
            if(this.handler) {
                this.handler(event, ...props);
            }
            // propagate click event up
            this.$emit("click", event);
        }
    },
    // TODO: https://dev.appcheck-ng.com/appcheck-ng/appcheck-webgui/-/commit/601e52d41357c09dd4211b516382fc5e304e1453
    template: `
        <a
            v-bind:class="['btn', disabled ? 'btn-disabled' : '']"
            v-on:click.left.stop="btnclick($event, 'left')"
            v-on:click.middle="btnclick($event, 'middle')"
            v-on:click.right.stop="btnclick($event, 'right')"
            v-on:keyup.enter.stop="btnclick($event, 'enter')"
            :title="title"
            :alt="title"
        >
            <i v-if="icon && !right" v-bind:class="['fa', icon]" />
            <span v-if="value" :class="['', spanClass]">{{ value }}</span>
            <i v-if="icon && right" v-bind:class="['fa', icon]" />
        </a>
    `
}

export const ApckToggleButton = {
    props: {
        handler: {
            type: Function
        },
        title: {
            type: String,
            default: ''
        },
        value: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            default: 'fa-square-o'
        },
        iconCheck: {
            type: String,
            default: 'fa-check-square'
        },
        right: {
            type: Boolean,
            default: false
        }
    },
    data: function() {
        return {
            active_value: this.value
        };
    },
    watch: {
        value: function(val){
            //After DOM render
            this.$nextTick(function () {
                this.active_value = this.value;
            });
        }
    },
    methods: {
        btnclick: function() {
            this.active_value = !this.active_value;
            this.$emit('input', this.active_value);
            // Black magic, :)
            // basically it allows any arguments to be passed
            if(this.handler) {
                this.handler.apply(arguments);
            }
        }
    },
    template: `
        <a v-bind:class="['btn', 'btn-check', active_value ? 'active' : '']" v-on:click="btnclick()">
            <input ref="check" type="checkbox" :checked="active_value" autocomplete="off">

            <i v-if="!right" v-bind:class="['fa', active_value ? iconCheck : icon]" />
            {{ title }}
            <i v-if="right" v-bind:class="['fa', active_value ? iconCheck : icon]" />
        </a>
    `
}

export const ApckToolbar = {
    props: {
        styled: {
            type: Boolean,
            default: true
        }
    },
    template: `
        <div v-bind:class="[styled ? 'styled' : '', 'toolbar']">
            <slot />

            <div v-if="$slots.right" class="apck-right">
                <slot name="right" />
            </div>
        </div>
    `
}

export const ApckPageBar = /*#__PURE__*/ Vue.extend({
    props: {
        store: {
            type: Object,
            required: true
        },
        showFirst: {
            type: Boolean,
            default: true
        },
        showLast: {
            type: Boolean,
            default: true
        },
        // whether to treat page size updates as local
        limitUpdateLocal: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        firstPage: function() {
            this.store.first();
        },
        previousPage: function() {
            this.store.prev();
        },
        nextPage: function() {
            this.store.next();
        },
        lastPage: function() {
            this.store.last();
        },
        refresh: function() {
            this.store.load(this.store.lastParams);
        },
        setLimit: function() {
            this.store.setLimit(this.store.limit, this.limitUpdateLocal);
            this.store.setPage(1);
        },
        setPage: function() {
            this.store.setPage(this.store.page);
        }
    },
    template: `
        <apck-toolbar>
            <div class="pagination apck-left">
                <apck-button v-if="showFirst" icon="fa-step-backward" :handler="firstPage" title="First Page" />
                <apck-button icon="fa-backward" :handler="previousPage" title="Previous Page" />

                <apck-sep />

                <span class="apck-html-block">Limit</span>
                <div class="field-holder page-limit">
                    <div class="form-field">
                        <input type="text" v-on:change="setLimit" v-model="store.limit">
                    </div>
                </div>
                <span class="apck-html-block">
                    Page
                </span>
                <div class="field-holder">
                    <div class="form-field">
                    <input type="text" v-on:change="setPage" v-model="store.page">
                    </div>
                </div>
                <span class="apck-html-block">
                    of {{ store.pages }}
                </span>

                <apck-sep />

                <apck-button icon="fa-forward" :handler="nextPage" title="Next Page" />
                <apck-button v-if="showLast" icon="fa-step-forward" :handler="lastPage" title="Last Page" />

                <apck-sep />

                <apck-button icon="fa-refresh" :handler="refresh" title="Refresh"/>
            </div>

            <slot />

            <template v-slot:right>
                <div class="pagination-records">
                    <span class="apck-html-block">
                        Showing {{ store.recStart }} to {{ store.recEnd }} of {{ store.total }} records
                    </span>
                </div>
            </template>

        </apck-toolbar>
    `
});

export const ApckPageBarNew = /*#__PURE__*/ ApckPageBar.extend({
    template: `
        <div class="pagination">
        
            <div class="pagination-group">
                <span>Rows per page</span>
                <div class="field-holder">
                    <div class="form-field">
                        <input type="text" v-on:change="setLimit" v-model="store.limit">
                    </div>
                </div>
            </div>


            <div class="pagination-group">
                <span>Page</span>
                <div class="field-holder">
                    <div class="form-field">
                        <input type="text" v-on:change="setPage" v-model="store.page">
                    </div>
                </div>
                <span class="text-muted">of</span>
                <span>{{ store.pages }}</span>
            </div>
            
            <div class="pagination-group">
                <span>{{ store.recStart }} - {{ store.recEnd }}</span>
                <span class="text-muted">of</span>
                <span>{{ store.total }}</span>
                <div class="pagination-nav">
                    <apck-button v-if="showFirst" :disabled="store.page === 1" icon="fa-regular fa-chevrons-left" :handler="firstPage" title="First Page"/>
                    <apck-button :disabled="store.page === 1" icon="fa-regular fa-chevron-left" :handler="previousPage" title="Previous Page"/>
                    <apck-button :disabled="store.page === store.pages" icon="fa-regular fa-chevron-right" :handler="nextPage" title="Next Page"/>
                    <apck-button v-if="showLast" :disabled="store.page === store.pages" icon="fa-regular fa-chevrons-right" :handler="lastPage" title="Last Page"/>
                </div>
                
                <apck-button icon="fa-refresh" :handler="refresh" title="Refresh"/>
            </div>

        </div>
    `
});

export const ApckMask = {
    props: {
        value: {
            type: String,
            default: 'Loading Please Wait...'
        },
        target: {
            type: [String, Function],
            required: false
        },
        root: {
            type: [String, Function],
            required: false
        },
        trigger: {
            type: Boolean,
            default: false
        }
    },
    data: function() {
        return {
            top: 0,
            left: 0,
            height: 0,
            width: 0,
            rootRect: null
        }
    },
    methods: {
        getComponent: function() {
            if (typeof this.root === 'function') {
                var root = this.root(this);
            } else {
                var root = this.$parent.$el;
            }

            if (typeof this.target === 'function') {
                var p = this.target(this);
            } else {
                var p = this.target ? this.$parent.$parent.$refs[this.target] : this.$parent.$el;
            }
            if(p) {
                this.rootRect = root.getBoundingClientRect();
            }
            if(p) {
                var rect = p.getBoundingClientRect();
                var offset = this.offset(p);
                this.top = offset.top;
                this.left = offset.left;
                this.height = rect.height;
                this.width = rect.width;
            }
        },
        offset: function(el) {
            var offsetTop = this.rootRect ? this.rootRect.top : 0;
            var offsetLeft = this.rootRect ? this.rootRect.left : 0;
            var rect = el.getBoundingClientRect();

            return {
                top: rect.top - offsetTop,
                left: rect.left - offsetLeft
            };
        }
    },
    computed: {
        getStyle: function() {
            return {
                top: this.top + 'px',
                left: this.left + 'px',
                height: this.height + 'px',
                width: this.width + 'px'
            };
        }
    },
    watch: {
        trigger: function(val){
            //After DOM render
            this.$nextTick(function () {
                this.getComponent();
            });
        }
    },
    mounted() {
        this.getComponent();
    },
    template: `
        <div
            v-show="trigger"
            class="loadmask"
            v-bind:style="getStyle"
        >
            <span>
                <h2>
                    <i class="fa fa-spinner fa-spin"></i>
                    {{value}}
                </h2>
            </span>
        </div>
    `
}

export const ApckColWrapper = {
    template: `
        <div class="cell">
            <span class="cell-value">
                <slot />
            </span>
        </div>
    `
}

export const ApckColumn = /*#__PURE__*/ Vue.extend({
    props: {
        mapping: {
            type: [String, Function],
            required: true
        },
        column: {
            type: Object,
            required: true
        },
        record: {
            type: Object,
            required: true
        },
        table: {
            type: Object,
            default: null
        },
        propClass: {
            type: String,
            default: '',
        },
        // html-mode: the column will display a custom html element
        // instead of text-only data
        html: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        rawValue: function() {
            if (typeof this.mapping === 'function') {
                return this.mapping(this.record);
            }
            var components = this.mapping.split('.');
            var name = components.shift();
            // attrs remain after shift
            var attrs = components;
            var dataObj = this.record[name];

            attrs.forEach(function(i) {
                if (dataObj) {
                    dataObj = dataObj[i];
                }
            });

            return dataObj;
        }
    },
    computed: {
        _raw: function() {
            return this.rawValue();
        }
    },
    template: `
        <apck-col-wrapper>
            <span v-if="html" v-html="_raw" v-on:click.stop />
            <span v-else>{{ _raw }}</span>
        </apck-col-wrapper>
    `
});

export const ApckVulnColumn = /*#__PURE__*/ ApckColumn.extend({
    data: function(){
        var record = this.rawValue();

        var crit = 0;
        var high = 0;
        var medium = 0;
        var low = 0;

        if(record instanceof Array) {
            crit = record[0];
            high = record[1];
            medium = record[2];
            low = record[3];
        }

        return {
            crit: crit,
            high: high,
            medium: medium,
            low: low,
        }
    },
    template: `
        <apck-col-wrapper>
            <strong class="status-box emphasis-critical">{{ crit }}</strong> /
            <strong class="status-box emphasis-bad">{{ high }}</strong> /
            <strong class="status-box emphasis-neutral">{{ medium }}</strong> /
            <strong class="status-box emphasis-good">{{ low }}</strong>
        </apck-col-wrapper>
    `
});

export const ApckVulnColumnNew = /*#__PURE__*/ ApckVulnColumn.extend({
    methods: {
        zeroClass(value) {
            return value === 0 ? 'impact-zero' : '';
        }
    },
    template: `
        <div class="cell vuln-counts">
            <ui-tooltip content="Critical" :class="['impact impact-critical', zeroClass(crit)]">{{ crit }}</ui-tooltip>
            <ui-tooltip content="High" :class="['impact impact-high', zeroClass(high)]">{{ high }}</ui-tooltip>
            <ui-tooltip content="Medium" :class="['impact impact-medium', zeroClass(medium)]">{{ medium }}</ui-tooltip>
            <ui-tooltip content="Low" :class="['impact impact-low', zeroClass(low)]">{{ low }}</ui-tooltip>
        </div>
    `
});

export const ApckLinkColumn = /*#__PURE__*/ ApckColumn.extend({
    methods: {
        rowUrl: function() {
            var parent = this.$parent;
            if(parent.rowUrl) {
                var mapping = parent.rowUrl(this.record);
                if (mapping) {
                    return mapping;
                }
            }
            return null;
        }
    },
    template: `
        <apck-col-wrapper>
            <a v-if="rowUrl() && !globalFlags.spa" :href="rowUrl()">
                {{ _raw }}
            </a>
            <router-link v-else-if="rowUrl()" :to="rowUrl()">
                {{ _raw }}
            </router-link>
            <span v-else>
                {{ _raw }}
            </span>
        </apck-col-wrapper>
    `
});

export const ApckAdminUserLinkColumn = /*#__PURE__*/ ApckColumn.extend({
    methods: {
        rowUrl: function() {
            return {
                name: 'users.edit',
                params: {
                    user_id: this.record.admin_user._id
                }
            }
        }
    },
    template: `
        <apck-col-wrapper>
            <i v-if="this.record.disabled_explicitly" class="fa fa-lock is-disabled"></i>
            <router-link v-if="this.record._id" :to="rowUrl()" :class="this.record.disabled ? 'is-disabled' : ''">
                {{ this.record.admin_user.name }}
            </router-link>
            <span v-else>
                {{ this.record.admin_user.name }}
            </span>
        </apck-col-wrapper>
    `
});

export const ApckBoolColumn = /*#__PURE__*/ ApckColumn.extend({
    template: `
        <apck-col-wrapper class="bool-column">
            <i v-bind:class="['fa-regular', _raw ? 'fa-check' : 'fa-xmark']"></i>
        </apck-col-wrapper>
    `
});

export const ApckHealthColumn = /*#__PURE__*/ ApckColumn.extend({
    computed: {
        healthClass: function() {
            var map = { good: 'health-tag--good', ok: 'health-tag--ok', bad: 'health-tag--bad', dormant: 'health-tag--dormant' };
            return map[this._raw] || 'health-tag--bad';
        },
        healthLabel: function() {
            var map = { good: 'Healthy', ok: 'Attention', bad: 'At Risk', dormant: 'Dormant' };
            return map[this._raw] || 'Unknown';
        },
        healthTooltip: function() {
            return (this.record && this.record.health_tooltip) || '';
        }
    },
    template: `
        <apck-col-wrapper>
            <span v-tooltip="healthTooltip" :class="['health-tag', healthClass]">{{ healthLabel }}</span>
        </apck-col-wrapper>
    `
});

export const ApckBadgeColumn = /*#__PURE__*/ ApckColumn.extend({
    computed: {
        badgeMap: function() {
            return (this.column && this.column.badgeMap) || {};
        },
        badgeClass: function() {
            var variant = this.badgeMap[this._raw] || 'default';
            return 'sev-badge sev-badge--' + variant;
        },
        badgeLabel: function() {
            var labelMap = (this.column && this.column.labelMap) || null;
            if (labelMap && labelMap[this._raw]) return labelMap[this._raw];
            return this._raw || '';
        },
        badgeTooltip: function() {
            var tooltipMap = (this.column && this.column.tooltipMap) || null;
            if (tooltipMap && this._raw && tooltipMap[this._raw]) return tooltipMap[this._raw];
            return null;
        }
    },
    template: `
        <apck-col-wrapper>
            <span v-if="_raw" :class="badgeClass" v-tooltip="badgeTooltip || undefined">{{ badgeLabel }}</span>
        </apck-col-wrapper>
    `
});

export const ApckInternalHubColumn = /*#__PURE__*/ ApckColumn.extend({
    data: function(){
        var record = this.rawValue();

        var value = false;
        if(record !== '__any_public_hub__') {
            value = true;
        }

        return {
            value: value
        }
    },
    template: `
        <apck-col-wrapper>
            <i v-bind:class="['fa', value ? 'fa-check' : 'fa-times']"></i>
        </apck-col-wrapper>
    `
});

export const ApckCheckboxColumn = /*#__PURE__*/ ApckColumn.extend({
    props: {
        colClass: {
            type: String,
            default: '',
        },
        input: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        value() {
            const c = this.record?.[this.table.rowIdentifier];
            if (this.table?.selectedRows && this.record) {
                return this.table.selectedRows.includes(c);
            }
        }
    },
    methods: {
        check() {
            this.$emit('row-selected', !this.value);
        },
    },
    template: `
        <apck-col-wrapper v-on:click.native.stop="check()" class="checkbox-cell">
            <input v-if="input" v-model="value" type="checkbox">
            <i v-else v-bind:class="['check-col fa', this.value ? 'fa-check-square-o checked' : 'fa-square-o unchecked', colClass]"
               v-bind:alt="this.value ? 'Checked' : 'Unchecked'"
               v-bind:title="this.value ? 'Checked' : 'Unchecked'"
            ></i>
        </apck-col-wrapper>
    `
});

export const ApckCheckboxColumnNew = /*#__PURE__*/ ApckCheckboxColumn.extend({
    template: `
        <apck-col-wrapper v-on:click.native.stop="check()" class="checkbox-cell checkboxcolumnnew">
            <input v-if="input" v-model="value" type="checkbox">
            <i v-else v-bind:class="['check-col', this.value ? 'fa-solid fa-duotone fa-square-check checked' : 'fa-regular fa-duotone fa-square unchecked', colClass]"
               v-bind:alt="this.value ? 'Checked' : 'Unchecked'"
               v-bind:title="this.value ? 'Checked' : 'Unchecked'"
            ></i>
        </apck-col-wrapper>
    `
});

const SimpleCheckboxNew = {
    props: {
        value: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        check() {
            this.$emit('checked', !this.value);
        },
    },
    template: `
        <div v-on:click="check()" class="checkboxcolumnnew">
            <i v-bind:class="['check-col', this.value ? 'fa-solid fa-duotone fa-square-check checked' : 'fa-regular fa-duotone fa-square unchecked']"
               v-bind:alt="this.value ? 'Checked' : 'Unchecked'"
               v-bind:title="this.value ? 'Checked' : 'Unchecked'"
            ></i>
        </div>
    `
}

export const ApckDateColumn = /*#__PURE__*/ ApckColumn.extend({
    props: {
        format: {
            type: String,
            default: 'DD/MM/YYYY HH:mm'
        },
        numberFormat: {
            type: String,
            default: 's'
        },
        defaultValue: {
            type: String,
            default: ' - '
        }
    },
    data: function() {
        var me = this;
        var tmp = me.rawValue();

        //TODO: This could be done at the record level???
        if (typeof tmp === "number") {
            if (me.numberFormat == 's') {
                tmp = tmp * 1000;
            }
            tmp = new Date(tmp);
        }

        var val = '';
        if (tmp instanceof Date) {
            val = formatDate(adjustTimezone(tmp), me.format);
        } else {
            //If it's a string let it pass, assume it's required...
            if (typeof tmp === "string") {
                const d = parseDate(tmp);
                val = d ? formatDate(d, me.format) : tmp;
            } else {
                val = me.defaultValue;
            }
        }

        return {
            value: val
        }
    },
    template: `
        <apck-col-wrapper>
            {{ value }}
        </apck-col-wrapper>
    `
});

export const ApckDateColumnNew = /*#__PURE__*/ ApckDateColumn.extend({
    props: {
        dateFormat: {
            type: String,
            default: 'DD/MM/YYYY'
        },
        timeFormat: {
            type: String,
            default: 'HH:mm'
        },
    },
    data: function() {
        var me = this;
        var tmp = me.rawValue();

        //TODO: This could be done at the record level???
        if (typeof tmp === "number") {
            if (me.numberFormat == 's') {
                tmp = tmp * 1000;
            }
            tmp = new Date(tmp);
        }

        var val = '';
        var date = '';
        var time = '';
        if (tmp instanceof Date) {
            val = adjustTimezone(tmp);
            date = formatDate(val, me.dateFormat);
            time = formatDate(val, me.timeFormat);
        } else {
            //If it's a string let it pass, assume it's required...
            if (typeof tmp === "string") {
                const d = parseDate(tmp);
                if (!d) {
                    date = tmp;
                } else {
                    date = formatDate(d, me.dateFormat);
                    time = formatDate(d, me.timeFormat);
                }
            } else {
                date = me.defaultValue;
            }
        }

        return {
            date: date,
            time: time
        }
    },
    template: `
        <div class="cell datetime-colum">
            
            <div class="date">
                {{ date }}
            </div>
            
            <span v-if="time" class="time">{{time}}</span>
        </div>
    `
});

export const ApckDateOnlyColumn = /*#__PURE__*/ ApckColumn.extend({
    props: {
        format: {
            type: String,
            default: 'DD/MM/YYYY'
        },
        numberFormat: {
            type: String,
            default: 's'
        },
        defaultValue: {
            type: String,
            default: ' - '
        }
    },
    data: function() {
        var me = this;
        var tmp = me.rawValue();

        //TODO: This could be done at the record level???
        if (typeof tmp === "number") {
            if (me.numberFormat == 's') {
                tmp = tmp * 1000;
            }
            tmp = new Date(tmp);
        }

        var val = '';
        if (tmp instanceof Date) {
            val = formatDate(adjustTimezone(tmp), me.format);
        } else {
            //If it's a string let it pass, assume it's required...
            if (typeof tmp === "string") {
                const d = parseDate(tmp);
                val = d ? formatDate(d, me.format) : tmp;
            } else {
                val = me.defaultValue;
            }
        }

        return {
            value: val
        }
    },
    template: `
        <apck-col-wrapper>
            {{ value }}
        </apck-col-wrapper>
    `
});

export const ApckDateYearsColumn = /*#__PURE__*/ ApckColumn.extend({
  props: {
    defaultValue: {
      type: String,
      default: ' - ',
    },
  },
  data: function () {
    var me = this;
    var rawDate = me.rawValue();

    if (typeof rawDate === 'number') {
      rawDate = new Date(rawDate * 1000);
    }

    let yearsDifference = '';

    if (rawDate instanceof Date || typeof rawDate === 'string') {
      const d = rawDate instanceof Date ? rawDate : new Date(rawDate);
      yearsDifference = isNaN(d.getTime()) ? me.defaultValue : yearsDiff(d, new Date());
    } else {
      yearsDifference = me.defaultValue;
    }

    return {
      value: yearsDifference,
    };
  },
  template: `
        <apck-col-wrapper>
            {{ value }}
        </apck-col-wrapper>
    `,
});

export const ApckUserColumn = /*#__PURE__*/ ApckColumn.extend({
    data: function() {
        var me = this;
        var rtn = {
            name: 'N/A',
            _id: null
        };
        var tmp = me.rawValue();

        if (tmp instanceof Object) {
            if (typeof tmp === "object") {
                rtn._id = tmp._id;
                rtn.name = tmp.name;
            }
        }

        return {
            value: rtn
        }
    },
    computed: {
        rowUrl: function () {
            var cmp = this;
            if (cmp.value._id) {
                return {
                    name: 'users.edit',
                    params: {
                        user_id: cmp.value._id
                    }
                };
            }
        }
    },
    template: `
        <apck-col-wrapper>
            <a v-if="value._id && !globalFlags.spa" :href="'/users/' + value._id">
                {{ value.name }}
            </a>
            <router-link v-else-if="rowUrl" :to="rowUrl">
                {{ value.name }}
            </router-link>
            <i v-else>{{ value.name }}</i>
        </apck-col-wrapper>
    `
});

export const ApckSubnetColumn = /*#__PURE__*/ ApckColumn.extend({
    computed: {
        value() {
            return this.rawValue().join(', ');
        },
    },
    template: `
        <apck-col-wrapper>
            {{ value }}
        </apck-col-wrapper>
    `
});

export const ApckPortsColumn = /*#__PURE__*/ ApckColumn.extend({
    computed: {
        value() {
            return this.rawValue().join(', ') || '-';
        },
    },
    template: `
        <apck-col-wrapper>
            {{ value }}
        </apck-col-wrapper>
    `
});

export const ApckAssetAddressColumn = /*#__PURE__*/ ApckColumn.extend({
    computed: {
        value() {
            return this.rawValue();
        },
        imageUrl() {
            return this.record.favicon
        },
        assetUrl() {
            if (this.record.scope_type !== 'Application') {
                return
            }
            const protocol = this.record.is_ssl || this.record.ports[0] === 443  ? 'https' : 'http';
            return `${protocol}://${this.record.discovered_target}:${this.record.ports[0]}`;
        },
    },
    methods: {
        showExternalLinkWarning(url) {
            this.$dialog.confirm(
                `We have provided a reference to this site because it has information that may be of interest in relation to your assets. You are leaving our site to visit an external link (opens in a new tab). Continue?`,
                'External Navigation',
                () => {
                    window.open(url, '_blank', 'noopener,noreferrer');
                }
            );
        },
    },
    template: `
        <apck-col-wrapper>
            <ui-layout align="center" gap="1">
                <!--
                <ui-image
                    v-if="imageUrl"
                    :src="imageUrl"
                    size="thumbnail-sm" 
                    border="none"
                    noShadow
                />
                -->
                <a v-if="assetUrl" :href="assetUrl" class="external" target="_blank" rel="noopener" @click.prevent.stop="showExternalLinkWarning(assetUrl)">
                    {{ value }}
                    <i class="fa-regular fa-arrow-up-right-from-square"></i>
                </a>
                <template v-else>{{ value }}</template>
            </ui-layout>
        </apck-col-wrapper>
    `
});

export const ApckAssetTypeColumn = /*#__PURE__*/ ApckColumn.extend({
    computed: {
        value() {
            switch (this.rawValue()) {
                case 'Application':
                    return {label:'Web app', icon: 'fa-regular fa-globe'};
                case 'Infrastructure':
                    return {label: 'Infra', icon: 'fa-regular fa-server'};
                default:
                    return {label: 'Unknown', icon: ''}
            }
        },
        color() {
            switch (this.rawValue()) {
                case 'Application':
                    return 'green';
                case 'Infrastructure':
                    return 'blue';
                default:
                    return ''
            }
        },
    },
    template: `
        <apck-col-wrapper>
            <ui-badge :label="value.label" :color="color" :icon-left="value.icon" />
        </apck-col-wrapper>
    `
});

export const ApckLocationColumn = /*#__PURE__*/ ApckColumn.extend({
    computed: {
        value() {
            return this.rawValue();
        },
    },
    template: `
        <apck-col-wrapper>
            <ui-layout gap="2">
                <ui-flag v-if="value" :code="value" size="sm"/>
                {{ value || '-' }}
            </ui-layout>
        </apck-col-wrapper>
    `
});

export const ApckScanProgressColumn = /*#__PURE__*/ ApckColumn.extend({
    data: function() {
        var me = this;
        var tmp = me.rawValue();

        var is_live = me.record['is_live'] ? me.record['is_live'] : false;

        return {
            value: tmp,
            live: is_live
        }
    },
    computed: {
        activityMap: function() {
            console.log(this.rawValue());
            var state = this.rawValue().state;
            var next_run = this.record.next_scan;

            function capitalizeFirstLetter(string) {
                if(string) {
                    string = string.toLowerCase();
                    return string.charAt(0).toUpperCase() + string.slice(1);
                }
                return "Unscheduled";
            }

            var nice_state = capitalizeFirstLetter(state);
            var mapping = {
                INITIALISIING: {
                    icon: 'fa-cogs',
                    name: nice_state,
                    class: ''
                },
                RUNNING: {
                    icon: 'fa-spinner fa-spin',
                    name: nice_state,
                    class: ''
                },
                PAUSED: {
                    icon: 'fa-pause',
                    name: nice_state,
                    class: ''
                },
                ABORTED: {
                    icon: 'fa-warning',
                    name: nice_state,
                    class: 'emphasis-bad'
                },
                ABORTING: {
                    icon: 'fa-warning',
                    name: nice_state,
                    class: 'emphasis-bad'
                },
                COMPLETED: {
                    icon: 'fa-check',
                    name: nice_state,
                    class: 'emphasis-good'
                },
                PASSED: {
                    icon: 'fa-check',
                    name: nice_state,
                    class: 'emphasis-good'
                },
                FAILED: {
                    icon: 'fa-remove',
                    name: nice_state,
                    class: 'emphasis-bad'
                },
                DETACHED: {
                    icon: 'fa-warning',
                    name: nice_state,
                    class: 'emphasis-neutral'
                },
                PENDING: {
                    icon: 'fa-spinner fa-spin',
                    name: nice_state,
                    class: ''
                }
            }

            var res = mapping[state];

            if(!res) {
                if(next_run && next_run != 'Never') {
                    res = {
                        icon: 'fa-clock-o',
                        name: 'Scheduled',
                        class: ''
                    }
                } else {
                    res = {
                        icon: 'fa-warning',
                        name: 'Unscheduled',
                        class: ''
                    }
                }
            }

            return res;
        }
    },
    template: `
        <apck-col-wrapper>

            <div v-if="!live">
                <span v-bind:class="['status-box', activityMap.class]">
                    <i v-if="activityMap.icon" v-bind:class="['icon', activityMap.icon]"></i>
                    <strong>
                        {{ activityMap.name }}
                    </strong>
                </span>
            </div>

            <div v-if="live" class="scan-progress">
                <div class="progress-wrap">
                    <div class="progress-bar" v-bind:style="{width: (100 * value.progress) + '%'}">
                    </div>
                    <span class="progress-text">
                        {{ value.activity }}
                    </span>
                </div>
                <span class="scan-progress-state">
                    {{ value.stage }}
                </span>
            </div>

            <div v-if="value.warning" class="warning"></div>
        </apck-col-wrapper>
    `
});

export const ApckScanProgressColumnNew = /*#__PURE__*/ ApckColumn.extend({
    data: function() {
        const progress = this.rawValue().progress;
        const is_live = this.record['is_live'] ? this.record['is_live'] : false;

        return {
            value: progress,
            live: is_live,
        }
    },
    computed: {
        status() {
            return this.rawValue().status;
        },
        progress() {
            return this.rawValue().progress;
        },
        completedDate() {
            const scan_complete = this.rawValue().scan_complete;
            if (!(['Completed', 'Aborted'].includes(this.activityMap.name) && scan_complete)) {
                return undefined;
            }
            const completed = new Date(scan_complete * 1000);
            let val = formatDate(adjustTimezone(completed), 'DD/MM/YY HH:mm');
            return val;
        },
        tooltip() {
            if (this.activityMap.name !== 'Running') {
                return this.activityMap.title;
            }
        },
        activityMap: function() {
            const status = this.status;
            const progress = this.progress;
            const state = progress.state;
            const activity = progress.activity;
            const next_run = this.record.next_scan;

            const mapping = {
                INITIALISIING: {
                    icon: 'fa-regular fa-gears',
                    name: 'Initialising',
                    class: 'scan-running',
                    title: ''
                },
                RUNNING: {
                    icon: 'fa-regular fa-loader fa-spinner fa-spin',
                    name: 'Running',
                    class: 'scan-running',
                    title: ''
                },
                PAUSED: {
                    icon: 'fa-regular fa-circle-pause',
                    name: 'Paused',
                    class: 'scan-neutral',
                    title: ''
                },
                ABORTED: {
                    icon: 'fa-regular fa-ban',
                    name: 'Aborted',
                    class: 'scan-negative',
                    title: ''
                },
                ABORTING: {
                    icon: 'fa-regular fa-loader fa-spinner fa-spin',
                    name: 'Aborting',
                    class: 'scan-negative',
                    title: ''
                },
                COMPLETED: {
                    icon: 'fa-regular fa-check',
                    name: 'Completed',
                    class: 'scan-positive',
                    title: ''
                },
                PASSED: {
                    icon: 'fa-regular fa-circle-check',
                    name: 'Passed',
                    class: 'scan-positive',
                    title: ''
                },
                FAILED: {
                    icon: 'fa-regular fa-circle-xmark',
                    name: 'Failed',
                    class: 'scan-negative',
                    title: ''
                },
                DETACHED: {
                    icon: 'fa-regular fa-triangle-exclamation',
                    name: 'Detached',
                    class: 'scan-muted',
                    title: ''
                },
                PENDING: {
                    icon: 'fa-regular fa-ellipsis',
                    name: 'Pending queue',
                    class: 'scan-neutral',
                    title: ''
                },
                SCHEDULED: {
                    icon: 'fa-regular fa-calendar-check',
                    name: 'Scheduled',
                    class: 'scan-neutral',
                    title: ''
                },
                UNSCHEDULED: {
                    icon: 'fa-regular fa-calendar-xmark',
                    name: 'Unscheduled',
                    class: 'scan-muted',
                    title: ''
                },
                QUEUED: {
                    icon: 'fa-regular fa-layer-group',
                    name: 'Queued for launch',
                    class: 'scan-neutral',
                    title: ''
                }
            }

            let res = mapping[state];

            if(!res) {
                if(next_run && next_run !== 'Never') {
                    res = mapping.SCHEDULED;
                } else {
                    res = mapping.UNSCHEDULED;
                }
            }

            if (this.live) {
                if (status === 'QUEUED') {
                    res = mapping.QUEUED;
                } else if (activity === 'Pending') {
                    res = mapping.PENDING;
                } else if (activity === 'Paused') {
                    res = mapping.PAUSED;
                } else {
                    res = mapping.RUNNING;
                }
            }

            if (status === 'COMPLETED' || status === 'FINISHED') {
                res = mapping.COMPLETED;
            } else if (status === 'ABORTED') {
                res = mapping.ABORTED;
            }

            return res;
        }
    },
    template: `
        <div class="cell scan-progress">
            
            <ui-tooltip>
                <template>
                    <div :class="['progress', activityMap.class]">
                        <i :class="['fa-regular', activityMap.icon]"></i>
                        <span v-if="['Running', 'Paused'].includes(activityMap.name)">
                            {{ activityMap.name }} ({{Math.round(100 * value.progress)}}%)
                        </span>
                        <span v-else>{{ activityMap.name }}</span>
                    </div>
            
                    <span v-if="completedDate" class="status-subtitle">{{completedDate}}</span>
                    <span v-if="['Paused'].includes(activityMap.name)" class="status-subtitle">{{progress.raw_stage}}</span>
                    
                    <span
                        v-if="activityMap.name === 'Running'"
                        class="status-subtitle"
                        style="text-decoration: underline;"
                    >
                        Check scan progress
                    </span>
                </template>
                
                <template #content>
                    <span v-if="tooltip">{{tooltip}}</span>
                    
                    <ul v-if="activityMap.name === 'Running'" class="tooltip-list">
                        <li v-if="rawValue().progress?.raw_stage">
                            <span class="label">Activity:</span>
                            <span class="value">{{progress.activity}}</span>
                        </li>
                        <li v-if="rawValue().scan_hub">
                            <span class="label">Scan hub:</span>
                            <span class="value">{{rawValue().scan_hub}}</span>
                        </li>
                        <li v-if="rawValue().progress?.stage">
                            <span class="label">Stage:</span>
                            <span class="value">{{progress.stage}}</span>
                        </li>
                        <li v-if="rawValue().progress?.detail?.average_delay">
                            <span class="label">Average delay:</span>
                            <span class="value">{{progress.detail.average_delay}}</span>
                        </li>
                        <li v-if="rawValue().progress?.detail?.request_total">
                            <span class="label">Total requests:</span>
                            <span class="value">{{progress.detail.request_total}}</span>
                        </li>
                        <li v-if="rawValue().progress?.detail?.request_rate">
                            <span class="label">Request rate:</span>
                            <span class="value">{{progress.detail.request_rate}}</span>
                        </li>
                        <li v-if="rawValue().progress?.detail?.error_count">
                            <span class="label">Errors:</span>
                            <span class="value">{{progress.detail.error_count}}</span>
                        </li>
                    </ul>
                </template>
            </ui-tooltip>

        </div>
    `
});


export const ApckLicenceBandLimitColumn = /*#__PURE__*/ ApckColumn.extend({
    computed: {
        value: function() {
            const raw = this.rawValue();
            if (raw === 0 || raw === null || raw === undefined) {
                return '∞';
            } else if (raw === -1) {
                return 0;
            }
            else return raw;
        }
    },
    template: `
        <apck-col-wrapper>
            {{ value }}
        </apck-col-wrapper>
        `
});

export const ApckNotesColumn = /*#__PURE__*/ ApckColumn.extend({
    template: `
        <div class="cell notes-cell">
            <span class="cell-value">{{ _raw }}</span>
        </div>
    `
});

export const ApckScanWarningsColumn = /*#__PURE__*/ ApckColumn.extend({
    computed: {
        isImpersonating() {
            return this.$permissions?.superadmin_group && (this.$permissions?.me !== this.$permissions?.impersonated)
        }
    },
    template: `
        <div
            :class="['cell', 'warning-cell', isImpersonating ? 'warning-cell--impersonation' : '']"
            v-if="_raw !== undefined">
            <div :class="['cell-value', _raw == 0 ? 'zero': '']" >
                <i v-if="_raw != 0" class="fa-regular fa-triangle-exclamation"></i>
                <span>{{ _raw }}</span>
            </div>
        </div>
    `
});

export const ApckLimitedTextColumn = /*#__PURE__*/ ApckLinkColumn.extend({
    template: `
        <div class="cell limited-text" v-if="_raw">
            <VueCustomTooltip :label="_raw" class="cell-value">
                <a class="cell-link" v-if="rowUrl() && !globalFlags.spa" :href="rowUrl()">
                    {{ _raw }}
                </a>
                <router-link class="cell-link" v-else-if="rowUrl()" :to="rowUrl()">
                    {{ _raw }}
                </router-link>
                <div v-else>
                    {{ _raw }}
                </div>
            </VueCustomTooltip>
        </div>
    `
});

export const ApckTableRow = {
    props: {
        rows: {
            type: Array,
            default: null,
            required: true
        },
        columns: {
            type: Array,
            default: null,
            required: true
        },
        actions: {
            type: Array,
            default: null,
            required: true
        },
        rowAction: {
            type: Function
        },
        sglRowAction: {
            type: Function
        },
        middleRowAction: {
            type: Function
        },
        ctrlRowAction: {
            type: Function
        },
        defaultType: {
            type: String,
            default: 'apck-column'
        },
    },
    methods: {
        rowclick: function(rec) {
            if(this.rowAction) {
                this.rowAction(rec);
            }
        },
        sglclick: function(rec) {
            if(this.sglRowAction) {
                this.sglRowAction(rec);
            }
        },
        columnType: function(ctype) {
            if(ctype) {
                return 'apck-' + ctype;
            }
            return this.defaultType;
        },
        actionCondition(handler, record) {
            if(handler) {
                return handler(record);
            }
            return true;
        }
    },
    template: `
        <tr v-if="rows.length > 0" v-for="row in rows" @click="sglclick(row)" v-on:dblclick="rowclick(row)">
            <td
                v-for="col in columns"
                v-if="!col.hidden"
                v-bind:class="[col.center ? 'apck-center' : '']"
            >
                <component
                    :is="columnType(col.ctype)"
                    :mapping="col.data"
                    :column="col"
                    :record="row.data"
                />
            </td>

            <td
                v-if="actions"
                data-label="Actions"
            >
                <div class="cell actions">
                    <apck-button
                        v-for="action in actions"
                        v-if="actionCondition(action.conditions, row)"
                        :icon="action.icon"
                        :title="action.title"
                        :handler="function(){ action.handler(row); }"
                        v-bind:class="[action.class, 'btn-short']"
                    />
                </div>
            </td>
        </tr>
    `
}

export const ApckTable = {
    components: {
        'apck-pagebar': ApckPageBar,
        'apck-new-pagebar': ApckPageBarNew,
        'draggable': draggable,
        'simple-checkbox': SimpleCheckboxNew
    },
    props: {
        tableId: {
            type: String,
            default: ''
        },
        hideSort: {
            type: Boolean,
            default: false,
        },
        parseFilters: {
            type: Function,
            default: null,
        },
        useHeaderComponent: {
            type: Boolean,
            default: false
        },
        showApckSearch: {
            type: Boolean,
            default: true
        },
        // whether the toolbar is sticky and follows you around while scrolling
        stickyToolbar: {
            type: Boolean,
            default: false
        },
        showOptions: {
            type: Boolean,
            default: false
        },
        showBar: {
            type: Boolean,
            default: false
        },
        useApckTable: {
            type: Boolean,
            default: true,
        },
        newStyleTable: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: null
        },
        src: {
            type: String,
            required: false,
        },
        autoload: {
            type: Boolean,
            default: true
        },
        start: {
            type: Number,
            default: 0
        },
        limit: {
            type: Number | String,
            default: 10
        },
        sort: {
            type: String,
            default: null
        },
        dir: {
            type: String,
            default: null
        },
        defaultType: {
            type: String,
            default: 'apck-column'
        },
        columns: {
            type: Array,
            default: []
        },
        rowLink: {
            type: Function
        },
        rowAction: {
            type: Function
        },
        sglRowAction: {
            type: Function,
        },
        middleRowAction: {
            type: Function
        },
        ctrlRowAction: {
            type: Function
        },
        customColumns: {
            type: Array,
            default() {
                return [];
            },
        },
        actions: {
            type: Array,
            default: null
        },
        actionBtnWidth: {
            type: Number,
            default: 30
        },
        columnMenu: {
            type: Array,
            default: null
        },
        rowTemplate: {
            type: String,
            default: 'apck-table-row'
        },
        showToolbar: {
            type: Boolean,
            default: true
        },
        showPageBar: {
            type: Boolean,
            default: true
        },
        searchBarClass: {
            type: String,
            default: () => '',
        },
        _selectedRows: {
            type: Array,
            default: function () {
                return [];
            }
        },
        colProps: {
            type: Object,
            default: () => {},
        },
        // Add in no border property
        /*
        _selectedRows update the table's `selectedRows` on 2 events: `datachanged` and `errorload`
        this makes it hard to make seamless selects that track across different pages
        (since on a data load they get reset back to `_selectedRows`). the individual row checkboxes
        also update the table's `selectedRows` (and not the passed in prop).
        this adds a flag to disable the updates to this.selectedRows.
        (i.e. if this flag is set to true - use the table's data instead, don't use _selectedRows at all).
        */
        disableSelectedRow: {
            type: Boolean,
            default: false,
        },
        // field to use to identify different rows (for row selection)
        rowIdentifier: {
            type: String,
            default: "_id"
        },
        method: {
            type: String,
            default: function () {
                return 'post';
            }
        },
        // if set, this flag will use "page_size" instead of "limit" in paginated queries
        usePageSize: {
            type: Boolean,
            default: false,
        },
        // function to generate `opts` for all requests made by Store
        requestOptsFunc: {
            type: Function,
            default: (opts) => (opts),
        },
        // what value to reset the page value (e.g. if API pagination starts at 1 instead)
        pageResetValue: {
            type: Number,
            default: 0,
        },
        // (store) => {...}
        // runs whenever store.updatePagination() does
        onUpdatePagination: {
            type: Function,
            default: () => {},
        },
        // (store) => {...}
        // runs whenever store.updateLimit() does
        onPageSizeUpdate: {
            type: Function,
            default: () => {},
        },
        // sets min-width as well as width on <colgroup> tags
        setColMinWidth: {
            type: Boolean,
            default: false,
        },
        // adds <colgroup> to the table for fixed table width management
        colGroup: {
            type: Boolean,
            default: true,
        },
        // whether to treat page size updates as local
        limitUpdateLocal: {
            type: Boolean,
            default: false,
        },
        // whether to show span overflow in table
        overflow: {
            type: Boolean,
            default: false,
        },
        backCompatActionWidth: {
            type: Boolean,
            default: false,
        },
        _rowClickOverride: {
            type: Function,
            default: null,
        },
        // Store callback fn
        storeCallback: {
            type: Function,
            default: null,
        },
        // flag for triggering the border
        noBorder: {
            type: Boolean,
            default: false,
        },
        // When true, the Actions column renders on the LEFT side (before data
        // columns) instead of the RIGHT side (default).
        actionsOnLeft: {
            type: Boolean,
            default: false,
        },
        // When provided, the table uses this store directly instead of creating
        // a new server-backed Store. Useful with LocalStore for client-side data
        // caching and filtering without AJAX.
        localStore: {
            type: Object,
            default: null,
        },
        showColumnPicker: {
            type: Boolean,
            default: false
        },
        // whether to use ApckMask during queryset loading
        useMask: {
            type: Boolean,
            default: true,
        },
        show_error_flash: {
            type: Boolean,
            default: false
        },
        rowClass: {
            type: Function,
            default: null
        },
    },
    data: function() {
        return {
            loaded: false,
            store: {},
            rows: [],
            selectedRows: [],
            search: '',
            showFilters: false,
            searchActive: false,
            pickedColumns: [],
            pickerDrag: false,
        };
    },
    methods: {
        width: function(width, _default='auto') {
            const isNumeric = function (num) {
                return (typeof(num) === 'number' || typeof(num) === "string" && num.trim() !== '') && !isNaN(num);
            };
            if(width) {
                return isNumeric(width) ? width + 'px' : width
            }
            return _default;
        },
        storeRows: function() {
            console.log(this.store);
        },
        rowUrl: function(rec) {
            if(this.rowLink) {
                return this.rowLink(rec);
            }
            return null;
        },
        // to handle both single- and double-clicks we need to
        // handle it ourselves with timers since we'll only
        // be allowed to attach either one of @click or @dblclick
        // 200ms delay between clicks seems to work well
        rowclick: function(event, rec, ctrl=false, middle=false) {
            if (this._rowClickOverride) {
                this._rowClickOverride(this, rec);
                return;
            }

            if (middle && this.middleRowAction) {
                this.middleRowAction(rec);
            } else if (ctrl && this.ctrlRowAction) {
                this.ctrlRowAction(rec);
            } else if (!this._clickTimeout) {
                // single click
                this._clickTimeout = setTimeout(() => {
                    if (this.sglRowAction) {
                        // Check if clicked element or its parent has button class to avoid bubbling
                        if (event.target.classList.contains('button') || event.target.closest('.button')) {
                            return;
                        }

                        this.sglRowAction(rec);
                    }
                    this._clickTimeout = null;
                }, 200);
            } else {
                // double click
                clearTimeout(this._clickTimeout);
                this._clickTimeout = null;
                if (this.rowAction) this.rowAction(rec);
            }
        },
        rowSelected: function (selected, row) {
            var id = row.get(this.rowIdentifier);
            if (selected && !this.selectedRows.includes(id)) {
                this.selectedRows.push(id);
            } else {
                this.selectedRows = this.selectedRows.filter(e => e !== id);
            }
            this.$emit('update:selectedRows', this.selectedRows, this.store.getPage(), this.rows);
        },
        actionClick: function(handler, record) {

        },
        columnType: function(ctype) {
            if(ctype) {
                return 'apck-' + ctype;
            }
            return this.defaultType;
        },
        actionCondition(handler, record) {
            if(handler) {
                return handler(record);
            }
            return true;
        },
        selectAll: function(status) {
            if (status) {
                this.selectedRows.push(...this.rows.map(r => r.get(this.rowIdentifier)));
            } else {
                this.selectionClearPage();
            }
            this.$emit('update:selectedRows', this.selectedRows, this.store.getPage(), this.rows);
        },
        selectionClear: function() {
            // clears the selected rows on all pages
            this.selectedRows = [];
            this.$emit('update:selectedRows', this.selectedRows, this.store.getPage(), this.rows);
        },
        selectionClearPage: function() {
            // clears the selected rows on the current page
            const rowsToRemove = new Set(this.rows.map(r => r.get(this.rowIdentifier)));
            this.selectedRows = this.selectedRows.filter(row => !rowsToRemove.has(row));
            this.$emit('update:selectedRows', this.selectedRows, this.store.getPage(), this.rows);
        },
        toggleFilters: function() {
            this.showFilters = !this.showFilters;
        },
        getColStyle(col) {
            if (this.setColMinWidth && !col?.ctype) {
                return { minWidth: this.width(col.width) };
            }
            return { width: this.width(col.width), minWidth: this.width(col.minWidth, '40px') };
        },
        getActionColStyle() {
            return { width: this.width(this.actionWidth), maxWidth: this.width(this.actionWidth) };
        },
        emitRadioChange() {
            this.$emit(
                'update:radiobox',
            );
        },
        updateSearchStore(initLoad = false) {
            // Set the page if it's not the first load
            if(!initLoad) this.store.setPage(1, true);

            //Set the query in the store
            this.store.load({
                page: 1,
                query: this.search
            });

            this.searchActive = !!this.search;
        },
        submitSearch() {
            // Don't submit if the query is already active
            if(this.search === this.getUrlSearchQuery()) return;

            this.updateSearchStore();
            this.updateUrlSearchQuery(this.search);
        },
        clearSearch() {
            this.search = '';
            this.updateSearchStore();
            this.updateUrlSearchQuery(this.search);
        },
        updateUrlSearchQuery(searchQuery) {
            const query = { ...this.$route.query };

            if (!searchQuery) {
                delete query.query;
            } else {
                query.query = searchQuery;
            }

            this.$router.push({
                path: this.$route.path,
                query,
            });
        },
        getUrlSearchQuery(){
            return this.$route?.query.query
        },
        searchIconHandler() {
            if (this.searchActive) {
                this.clearSearch();
            } else {
                this.submitSearch();
            }
        },
        saveColumnPickerData() {
            if (!this.tableId) {
                return;
            }
            let cols = this.pickedColumns.map((c) => {
                return {
                    heading: c.heading,
                    width: c.width,
                    hidden: c.hidden || false,
                    direction: c.direction || null
                }
            });
            // Remove cols without headings
            cols = cols.filter((c) => !!c.heading);
            return localStorage.setItem(this.tableId, JSON.stringify(cols));
        },
        loadColumnPickerData() {
            const defaultCols = cloneDeep(this.columns);

            if (this.tableId) {
                try {
                    const stored = localStorage.getItem(this.tableId);
                    if (stored) {
                        const pickedCols = JSON.parse(stored);
                        const newCols = [];
                        pickedCols.map((c) => {
                            const index = defaultCols.findIndex(col => col.heading === c.heading);
                            if (index !== -1) {
                                // Make sure only sortable columns have a direction set
                                if (c.direction && defaultCols[index].direction === undefined) {
                                    delete c.direction;
                                }
                                // Assign stored column attributes over defaults, and push to final array
                                newCols.push({...defaultCols[index], ...c});
                                // Remove this column from defaultCols now. We will use the remaining columns at the end
                                defaultCols.splice(index, 1);
                            }
                        })
                        // Update cols with any defaults that are missing from the stored data
                        return [...newCols, ...defaultCols];
                    }
                } catch (e) {
                    console.error(e);
                }
            }
            return defaultCols;
        },
        toggleColumnSelect(column) {
            const index = this.pickedColumns.findIndex(pickedCol => pickedCol.heading === column.heading);
            if (index !== -1) {
                const col = this.pickedColumns[index];
                this.$set(col, 'hidden', !col.hidden);
                this.saveColumnPickerData();
            }
        },
        resetColumnPicker() {
            this.pickedColumns = cloneDeep(this.columns);
            this.saveColumnPickerData();
        },
        sortColumn(col) {
            const picked_index = this.pickedColumns.findIndex(pickedCol => pickedCol.heading === col.heading);
            const default_index = this.columns.findIndex(defaultCol => defaultCol.heading === col.heading);
            if (picked_index !== -1) {
                // update column and save picker data
                const dir = this.pickedColumns[picked_index].direction;
                const defaultDir = this.columns[default_index].direction;
                if (defaultDir === undefined) {
                    // this column should not be sorted
                    return;
                }
                this.pickedColumns[picked_index].direction = dir === 'asc' ? 'desc': 'asc';
                this.saveColumnPickerData();

                // reload table with sort filter
                this.store.load({...this.store.lastParams, sort: col.data, dir: col.direction.toUpperCase()});
            }
            this.$emit('sort-click', col);
        },
        isSelected(row) {
            try {
                return this.selectedRows.includes(row.get(this.rowIdentifier))
            } catch (e) {
                return false;
            }
        },
        actionColor(action) {
            const map = {
                'btn-negative': 'red',
                'btn-warning': 'yellow',
                'btn-positive': 'green',
            };
            return map[action.class] || '';
        }
    },
    computed: {
        cmp() {
            return this;
        },
        colSpan: function() {
            var len = 0;
            for (let i = 0, l = this.pickedColumns.length; i < l; i++) {
                if (this.pickedColumns[i].hidden !== true) {
                    len++;
                }
            }
            if (this.actions) {
                len++;
            }
            return len;
        },
        actionWidth: function() {
            if (this.newStyleTable) {
                return 60;
            }
            let buttonPadding = 4;
            if (this.backCompatActionWidth) {
                buttonPadding = 20;
            }
            if(this.actions) {
                return (this.actions.length * this.actionBtnWidth + buttonPadding);
            }
            return 0;
        },
        searchTitle: function() {
            return this.searchActive ? 'Clear Search' : 'Submit Search';
        },
        searchIcon: function() {
            return this.searchActive ? 'fa-times' : 'fa-regular fa-magnifying-glass';
        },
        groupedActions() {
            return this.actions?.filter(action => !action.useOwnCol) ?? [];
        },
        ownColActions() {
            return this.actions?.filter(action => action.useOwnCol) ?? [];
        },
        getOwnColActionsWidth(){
            if (!this.ownColActions?.length) return 0;

            const widthFromActions = this.ownColActions.reduce((total, action) => {
                if (action.hideLabel) {
                    return total + 36;
                }
                return total + (action.colWidth || 0);
            }, 0);

            //total width defined in actions, plus padding
            const widthCalc = widthFromActions + 32

            return { width: this.width(widthCalc), maxWidth: this.width(widthCalc) };
        },
        allRecordsAreSelected() {
            return this.selectedRows.length !== 0 && this.selectedRows.length === this.store.total;
        },
        allVisibleRecordsAreSelected() {
            const visibleRows = this.rows.map(row => row.get(this.rowIdentifier));
            const visibleSelectedRows = this.rows.filter(row => this.isSelected(row)).map(row => row.get(this.rowIdentifier));
            return visibleSelectedRows.length !== 0 && visibleSelectedRows.length === visibleRows.length;
        }
    },
    mounted: function() {
        var cmp = this;

        // load column picker settings from localStorage
        this.pickedColumns = this.loadColumnPickerData();

        const searchQuery = cmp.getUrlSearchQuery();

        // Mount a data store on creation. If a localStore is provided (e.g. a
        // LocalStore instance for client-side caching) use that directly;
        // otherwise create a standard server-backed Store.
        var store;
        if (cmp.localStore) {
            store = cmp.localStore;
        } else {
            store = new Store({
                page: 1,
                url: cmp.src,
                method: cmp.method,
                autoLoad: !!searchQuery ? false : cmp.autoload,
                start: cmp.start,
                limit: cmp.limit,
                sort: cmp.sort,
                dir: cmp.dir,
                usePageSize: cmp.usePageSize,
                requestOptsFunc: cmp.requestOptsFunc,
                pageResetValue: cmp.pageResetValue || 0,
                callback: cmp.storeCallback
            });
        }

        if (this.parseFilters) store.parseFilters = this.parseFilters;

        store.on('beforeload', function() {
           cmp.loaded = false;
        });

        store.on('datachanged', function(store, rawdata) {
            cmp.rows = store.data;
            if (!cmp.disableSelectedRow) cmp.selectedRows = cmp._selectedRows;
            cmp.loaded = true;
        });

        store.on('errorload', function(evt, store, rawdata) {
            cmp.rows = [];
            if (!cmp.disableSelectedRow) cmp.selectedRows = cmp._selectedRows;
            cmp.loaded = true;
        });

        if (this.onUpdatePagination) {
            const that = this;
            store.on('updatepagination', function(store, arg) {
                that.onUpdatePagination(store, arg);
            })
        }

        if (this.onPageSizeUpdate) {
            const that = this;
            store.on('updatepagesize', function(store, arg) {
                that.onPageSizeUpdate(store);
            })
        }

        if (this.show_error_flash) {
            store.on('showerrorflash', function(store, arg) {
                toastMessage({
                    type: 'error',
                    message: arg.message,
                });
            });
        }

        cmp.store = store;

        if (searchQuery) {
            this.search = searchQuery;
            cmp.updateSearchStore(true);
        }
    },
    watch: {
        src: function(url) {
            this.store.url = url;
            this.store.load();
        },
        loaded: function (val) {
            // wait for nextTick so that $refs are gathered
            this.$nextTick(() => {
                if (!this.$refs.cells) {
                    return;
                }
                var checkboxes = this.$refs.cells.filter(c => c.$options._componentTag === "apck-checkboxcolumn");
                if (checkboxes.length === 0 || checkboxes.length < this.rows.length) return;
                // row index should match checkbox array index, so if the row is selected we can tick the checkbox
                for (let i = 0; i < this.rows.length; i++) {
                    if (this.selectedRows.includes(this.rows[i].get(this.rowIdentifier))) {
                        checkboxes[i].$data.value = true;
                    }
                }
            });
        },
        columns: {
            handler() {
                this.pickedColumns = this.loadColumnPickerData();
            },
            deep: true
        }
    },
    template: `
        <div :class="['apck-table-main', newStyleTable ? 'vue-ui-datatable' : 'panel datatable', noBorder ? 'no-border' : '']">
            <div :class="[ stickyToolbar ? 'sticky-toolbar' : '' ]">
                <apck-title v-if="title" :title="title" />
                <apck-toolbar v-if="showToolbar" :class="[ 'toolbar-top' ]" >
                    <div v-if="showApckSearch" class="search-holder">
                        <div class="field-holder">
                            <div class="form-field">
                                <input
                                    type="text"
                                    v-on:keyup.enter="submitSearch()"
                                    v-model="search"
                                    placeholder="Search..."
                                >
                            </div>
                        </div>
                        
                        <apck-button v-if="!newStyleTable" :icon="searchIcon" @click.prevent="searchIconHandler()" :title="searchTitle" />
                    </div>

                    <template v-if="$slots.filters" v-slot:right>
                        <apck-button
                            :right="true"
                            :icon="showFilters ? 'fa-chevron-up' : 'fa-chevron-down'"
                            :handler="toggleFilters"
                            :value="showFilters ? 'Close Filters' : 'Open Filters'"
                            :title="showFilters ? 'Close Filters' : 'Open Filters'"
                        />
                    </template>

                    <slot name="tbar">
                        <div v-if="$slots.tbarBtnGroup || showColumnPicker" class="button-group">
                            <slot name="tbarBtnGroup" />
                            
                            <template v-if="showColumnPicker">
                                <ui-dropdown-base 
                                    v-if="newStyleTable"
                                    label="Edit Columns"
                                    iconLeft="fa-table"
                                    iconRight=""
                                    hideLabel
                                >
                                    <ui-layout
                                        direction="column"
                                    >
                                        <draggable
                                            :list="pickedColumns"
                                            :animation="100"
                                            @start="pickerDrag = true"
                                            @end="pickerDrag = false; saveColumnPickerData();"
                                        >
                                            <transition-group 
                                                type="transition" 
                                                :name="pickerDrag ? 'picker-list' : null" 
                                                tag="ul"
                                                class="flex gap-row-2 dir-column"
                                            >
                                                <ui-layout
                                                    v-for="column in pickedColumns.filter((c) => !!c.heading)"
                                                    :key="column.heading"
                                                    tag="li"
                                                    tabindex="0"
                                                    align="center"
                                                    justify="space-between"
                                                    style="cursor:grab;"
                                                >
                                                    <ui-input-checkbox 
                                                        :label="column.heading" 
                                                        :modelValue="!column.hidden" 
                                                        labelSize="base"
                                                        @update:modelValue="toggleColumnSelect(column)" 
                                                    />
                                                    
                                                    <ui-icon icon="fa-grip-lines" type="secondary" class="drag-handle"/>
                                                </ui-layout>
                                            </transition-group>
                                        </draggable>
                                        
                                        <hr />
                                        
                                        <ui-button 
                                            label="Reset Columns" 
                                            type="outline"
                                            iconLeft="fa-refresh"   
                                            tabindex="0"
                                            @click="resetColumnPicker()" 
                                        />
                                    </ui-layout>
                                </ui-dropdown-base>
                         
                                <apck-dropdown-button v-else class="column-picker" icon="fa-regular fa-table" :showCaret="false">
                                    <draggable
                                        :list="pickedColumns"
                                        :animation="100"
                                        @start="pickerDrag = true"
                                        @end="pickerDrag = false; saveColumnPickerData();"
                                    >
                                        <transition-group type="transition" :name="pickerDrag ? 'picker-list' : null" tag="ul">
                                            <li
                                                v-for="column in pickedColumns.filter((c) => !!c.heading)"
                                                :key="column.heading"
                                                @click="toggleColumnSelect(column)"
                                                tabindex="0"
                                            >
                                                <i v-if="column.hidden" class="checkbox fa-regular fa-square"></i>
                                                <i v-else class="checkbox fa-solid fa-square-check"></i>
                                                <span>{{ column.heading }}</span>
                                                <i class="drag-handle fa-regular fa-grip-lines"></i>
                                            </li>
                                        </transition-group>
                                    </draggable>
                                    <span class="divider"></span>
                                    <a
                                        class="btn"
                                        tabindex="0"
                                        @click="resetColumnPicker()"
                                    >
                                        <i class="fa-regular fa-refresh"></i>
                                        <span>Reset Columns</span>
                                    </a>
                                </apck-dropdown-button>
                            </template>
                        </div>
                    </slot>

                </apck-toolbar>

                <div v-if="$slots.filters" v-show="showFilters" class="toolbar-filters">
                    <slot name="filters" />
                </div>

                <div v-show="showOptions" :class="[ 'toolbar-options toolbar-filters', stickyToolbar ? 'sticky-toolbar-options' : '' ]" id="apck-toolbar-options">
                    <slot name="options" />

                </div>


                <div v-show="showBar" v-bind:class="['toolbar-filters', searchBarClass]">
                    <slot name="searchBar" />
                </div>
            </div>

            <div class="apck-table-panel panel-no-padding scrollx">
                <table :class="['apck-table', { 'show-overflow': overflow }]">

                    <colgroup v-if="colGroup">
                        <col
                            v-if="actionsOnLeft && ownColActions?.length > 0"
                            :style="getOwnColActionsWidth"
                        />
                        <col
                            v-if="actionsOnLeft && groupedActions?.length > 0"
                            :style="getActionColStyle()"
                        />
                        <col
                            v-for="col in pickedColumns"
                            v-if="!col.hidden"
                            :style="getColStyle(col)"
                        />
                        <col
                            v-if="!actionsOnLeft && ownColActions?.length > 0"
                            :style="getOwnColActionsWidth"
                        />
                        <col
                            v-if="!actionsOnLeft && groupedActions?.length > 0"
                            :style="getActionColStyle()"
                        />
                    </colgroup>

                    <thead>
                        <slot v-if="useHeaderComponent" name="headers" :rowsLength="rows.length" />
                        <tr v-else>
                            <th
                                v-if="actionsOnLeft && ownColActions?.length > 0"
                            >
                                <div class="cell header apck-no-pointer">
                                    <span class="cell-value">
                                        &nbsp;
                                    </span>
                                </div>
                            </th>
                            <th v-if="actionsOnLeft && groupedActions?.length > 0">
                                <div class="cell header apck-no-pointer">
                                    <span class="cell-value">
                                        &nbsp;
                                    </span>
                                </div>
                            </th>
                            <th v-for="col in pickedColumns" v-if="!col.hidden">
                                <div :class="['cell header', col.center ? 'apck-center' : '', col.right ? 'apck-text-right' : '']">
                                    
                                    <template v-if="col.ctype === 'checkboxcolumnnew'">
                                        <ui-input-checkbox
                                            v-if="newStyleTable"
                                            label="Select All"
                                            hideLabel
                                            :modelValue="allVisibleRecordsAreSelected"
                                            @update:modelValue="selectAll"
                                        />

                                        <simple-checkbox
                                            v-else
                                            :value="allVisibleRecordsAreSelected"
                                            @checked="selectAll"
                                        />
                                    </template>
                                    
                                    

                                    <span v-else class="cell-value" v-on:click="sortColumn(col)">
                                        {{col.heading}}
                                        <span v-if="col?.direction === ''" class="fa fa-stack">
                                            <i class="fa fa-caret-up" aria-hidden="true"></i>
                                            <i class="fa fa-caret-down" aria-hidden="true"></i>
                                        </span>
                                        <span v-else-if="col?.direction !== undefined">
                                            <i class="fa"
                                               v-bind:class="{ 'sort-hide': hideSort, 'fa-caret-down': col?.direction === 'desc', 'fa-caret-up': col?.direction === 'asc' }"
                                            ></i>
                                        </span>
                                    </span>
                                    <div v-if="columnMenu" class="header-menu">
                                        <div class="header-button">
                                            <i class="fa fa-chevron-down"></i>
                                            <div class="menu-holder"></div>
                                        </div>
                                    </div>
                                </div>
                            </th>
                            <th
                                v-if="!actionsOnLeft && ownColActions?.length > 0"
                            >
                                <div class="cell header apck-no-pointer">
                                    <span class="cell-value">
                                        &nbsp;
                                    </span>
                                </div>
                            </th> 
                            <th v-if="!actionsOnLeft && groupedActions?.length > 0">
                                <div class="cell header apck-no-pointer">
                                    <span class="cell-value">
                                        &nbsp;
                                    </span>
                                </div>
                            </th>
                        </tr>
                    </thead>

                    <tbody v-if="loaded">


                        <tr 
                            v-if="rows.length > 0"
                            v-for="row in rows"
                            :key="row.id"
                            v-on:click.exact="rowclick($event, row)"
                            v-on:click.ctrl="rowclick($event, row, true)"
                            v-on:click.middle="rowclick($event, row, false, true)"
                            :class="[sglRowAction ? 'row-highlight' : '', isSelected(row) ? 'selected' : '', rowClass ? rowClass(row) : '']"
                        >
                            <td
                                v-if="actionsOnLeft && ownColActions?.length > 0 && newStyleTable"
                                class="new-ui"
                            >
                                <ui-layout gap="0" justify="end">
                                    <ui-button
                                        v-for="(action, index) in ownColActions"
                                        :key="action.icon + index"
                                        v-if="actionCondition(action.conditions, row)"
                                        :label="action.title"
                                        :class="action.class"
                                        :iconLeft="action.icon"
                                        :hideLabel="action.hideLabel"
                                        :disabled="action.protected && row.raw.protected"
                                        type="ghost"
                                        size="sm"
                                        @click="action.handler(row)"
                                    />
                                </ui-layout>
                            </td>

                            <td
                                v-if="actionsOnLeft && groupedActions?.length > 0"
                                data-label="Actions"
                            >
                                <div v-if="newStyleTable" class="cell">
                                    <div class="cell-value" v-if="groupedActions?.length > 0">
                                        <ui-dropdown-base
                                            v-if="newStyleTable"
                                            label="Actions"
                                            iconLeft="fa-ellipsis-vertical"
                                            iconRight=""
                                            type="ghost"
                                            hideLabel
                                        >
                                            <ui-layout
                                                direction="column"
                                                gap="2"
                                                tag="ul"
                                                align="stretch"
                                            >
                                                <li v-for="action in actions"
                                                    v-if="actionCondition(action.conditions, row) && !action.useOwnCol"
                                                >
                                                    <ui-button
                                                        :label="action.title"
                                                        :iconLeft="action.icon"
                                                        :color="actionColor(action)"
                                                        @click="action.handler(row)"
                                                        type="ghost"
                                                    />
                                                </li>
                                            </ui-layout>
                                        </ui-dropdown-base>
                                    </div>
                                </div>

                                <div v-else class="cell actions">
                                    <apck-button
                                        v-for="action in actions"
                                        v-bind:key="action.id"
                                        v-if="actionCondition(action.conditions, row) && !action.useOwnCol"
                                        :icon="action.icon"
                                        :title="action.title"
                                        :value="action.value"
                                        :handler="function(...props){ action.handler(row, ...props); }"
                                        v-bind:class="[action.class, !action.value ? 'btn-short' : '']"
                                    />
                                </div>
                            </td>
                            <td
                                v-for="col in pickedColumns"
                                v-if="!col.hidden"
                                :key="col.id || col.heading"
                                v-bind:class="[col.center ? 'apck-center' : '', col.right ? 'apck-text-right' : '']"
                            >
                                <template v-if="col.ctype === 'tags' && newStyleTable">
                                    <ui-input-tags
                                        v-if="row.data.tags?.length"
                                        :modelValue="row.data.tags"
                                        hideLabel
                                        disabled
                                        ref="cells"
                                    />
                                </template>
                                
                                <template v-else-if="col.ctype === 'checkboxcolumnnew' && newStyleTable">
                                    <ui-input-checkbox
                                        label="Select Row"
                                        hideLabel
                                        :modelValue="isSelected(row)"
                                        @update:modelValue="rowSelected($event, row)"
                                        ref="cells"
                                    />
                                </template>
                                
                                <component
                                    v-else
                                    :is="columnType(col.ctype)"
                                    :mapping="col.data"
                                    :column="col"
                                    :record="row.data"
                                    :table="cmp"
                                    :input="col?.input"
                                    :html="col.html"
                                    v-bind="colProps"
                                    @click.stop="() => {}"
                                    v-on:row-selected="rowSelected($event, row)"
                                    ref="cells"
                                />
                            </td>

                            <td
                                v-for="customColumn in customColumns"
                                :data-label="customColumn.label"
                                >
                                    <label :for="'radiobox_' + customColumn.radioBoxValue + '_' + row.id" v-if="customColumn?.ctype === 'radioboxcolumn'" style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; margin: 0;">
                                        <input 
                                            v-bind:class="['radio_' + customColumn.id]" 
                                            type="radio" 
                                            :name="customColumn.radioBoxName + '_' + row.id" 
                                            :value="customColumn.radioBoxValue"
                                            @change="emitRadioChange"
                                            :id="'radiobox_' + customColumn.radioBoxValue + '_' + row.id"
                                        >
                                    </label>
                            </td>
                            
                            <td
                                v-if="!actionsOnLeft && ownColActions?.length > 0 && newStyleTable"
                                class="new-ui"
                            >
                                <ui-layout gap="0" justify="end">
                                    <ui-button
                                        v-for="(action, index) in ownColActions"
                                        :key="action.icon + index"
                                        v-if="actionCondition(action.conditions, row)"
                                        :label="action.title"
                                        :class="action.class"
                                        :iconLeft="action.icon"
                                        :hideLabel="action.hideLabel"
                                        :disabled="action.protected && row.raw.protected"
                                        type="ghost"
                                        size="sm"
                                        @click="action.handler(row)"
                                    />
                                </ui-layout>
                            </td>

                            <td
                                v-if="!actionsOnLeft && groupedActions?.length > 0"
                                data-label="Actions"
                            >
                                <div v-if="newStyleTable" class="cell">
                                    <div class="cell-value" v-if="groupedActions?.length > 0">
                                        <ui-dropdown-base
                                            v-if="newStyleTable"
                                            label="Actions"
                                            iconLeft="fa-ellipsis-vertical"
                                            iconRight=""
                                            type="ghost"
                                            hideLabel
                                        >
                                            <ui-layout
                                                direction="column"
                                                gap="2"
                                                tag="ul"
                                                align="stretch"
                                            >
                                                <li v-for="action in actions"
                                                    v-if="actionCondition(action.conditions, row) && !action.useOwnCol"
                                                >
                                                    <ui-button 
                                                        :label="action.title"
                                                        :iconLeft="action.icon"
                                                        :color="actionColor(action)"
                                                        @click="action.handler(row)"
                                                        type="ghost"
                                                    />
                                                </li>
                                            </ui-layout>
                                        </ui-dropdown-base>
                                    </div>
                                </div>
                                
                                <div v-else class="cell actions">
                                    <apck-button
                                        v-for="action in actions"
                                        v-bind:key="action.id"
                                        v-if="actionCondition(action.conditions, row) && !action.useOwnCol"
                                        :icon="action.icon"
                                        :title="action.title"
                                        :value="action.value"
                                        :handler="function(...props){ action.handler(row, ...props); }"
                                        v-bind:class="[action.class, !action.value ? 'btn-short' : '']"
                                    />
                                </div>
                            </td>
                        </tr>

                        <tr v-if="rows.length == 0" class="apck-center">
                            <td :colspan="colSpan">
                                <apck-col-wrapper class="apck-empty-table">
                                    No row data to display
                                </apck-col-wrapper>
                            </td>
                        </tr>

                    </tbody>

                    <tbody v-if="!loaded">
                        <tr class="apck-center">
                            <td :colspan="colSpan">
                                <apck-col-wrapper>
                                    Loading row data
                                </apck-col-wrapper>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            
            <apck-new-pagebar v-if="showPageBar && newStyleTable" class="toolbar" :store="store" :limitUpdateLocal="limitUpdateLocal">
                <slot name="bbar" />
            </apck-new-pagebar>
            
            <apck-pagebar v-else-if="showPageBar" class="toolbar-bottom" :store="store" :limitUpdateLocal="limitUpdateLocal">
                <slot name="bbar" />
            </apck-pagebar>

            <ui-spinner v-if="newStyleTable" :show="!loaded && useMask" theme="dark"  />
            
            <apck-mask v-else :trigger="!loaded && useMask" />
        </div>
    `
}

export const ApckFloatRight = {
    template: `
        <div style="overflow: auto;">
            <div style="float: right">
                <slot></slot>
            </div>
        </div>
    `
}
